import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LanguageState {
    language: 'English' | 'Hindi';
  }

  const initialState: LanguageState = {
    language: 'English',
  };

  const languageSlice = createSlice({
    name: 'language',
    initialState,
    reducers: {
      setLanguage: (state, action: PayloadAction<'English' | 'Hindi'>) => {
        state.language = action.payload;
      },
    },
  });

  export const { setLanguage } = languageSlice.actions;
  export default languageSlice.reducer;